import React from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import cn from 'classnames';
import { ControlLabel } from 'react-bootstrap';

import PureInput from '../../components/PureInput/';

export const WebsiteQuestion = ({ field }) => {
    const hasError = field.touched && field.error;

    return (
        <div className={cn({ invalid: hasError })}>
            <ControlLabel htmlFor="company.website">
                Website <span className="helper">(optional)</span>
            </ControlLabel>
            {hasError && <div className="error">{field.error}</div>}
            <PureInput
                whenBlur={(event) => {
                    if (event.target.value.length > 0) {
                        tracking.ampli.formFieldCompleted({
                            form_field: 'website'
                        });
                    }
                }}
                whenFocus={() => {
                    tracking.ampli.formFieldStarted({
                        form_field: 'website'
                    });
                }}
                id="company.website"
                placeholder="www.example.com"
                type="url"
                {...field}
                parser={(w) => w.trim()}
            />
        </div>
    );
};
